export class DivisionModel {
  public id: string;
  public name: string = "";
  public printerName: string = "";
  public venueId: string;
}
